/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { Icon } from '@mpb-com/feather/components/atoms/icon';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './icon-list-item.styles';
import { IconListItemProps } from './types';

export const defaultTestId = 'icon-list-item';

export { IconListItemSkeleton } from './skeleton';

export const StyledIconListItem = styled.li.withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const IconListItem: FunctionComponent<IconListItemProps> = ({
    'data-testid': dataTestId = defaultTestId,
    className,
    isTransparent = false,
    icon,
    children,
    ...iconProps
}: IconListItemProps) => {
    return (
        <StyledIconListItem
            data-testid={dataTestId}
            isTransparent={isTransparent}
            className={className}
        >
            <Icon
                className="icon"
                data-testid={`${dataTestId}__icon`}
                {...iconProps}
            >
                {icon}
            </Icon>
            <div className="content" data-testid={`${dataTestId}__content`}>
                {children}
            </div>
        </StyledIconListItem>
    );
};
